let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kr4ZO")).then(() => parcelRequire('7WCvD'));